import { createContext, useContext } from "react";

export const UserLoginInfo = createContext<any>({});

export default UserLoginInfo;
